// extracted by css-extract-rspack-plugin
export default {"closeButtonContainer":"closeButtonContainer-U0m0LS","collaboratorName":"collaboratorName-XyW3Qb text-xl-medium"};